import { gql } from "@apollo/client";

export const VISITA_PUEDE_CAMBIAR_SNG = gql`
query visitaPuedeCambiarSNG($idEvaluacion: Int!) {
    visitaPuedeCambiarSNG(idEvaluacion: $idEvaluacion)
}`;

export default VISITA_PUEDE_CAMBIAR_SNG;